/**
 * ActivityIndicator - Current activity status display.
 *
 * @param {{ type: 'skiing'|'lift'|'stopped'|'traversing', runNumber?: number, liftNumber?: number }} props
 */
export default function ActivityIndicator({ type = 'stopped', runNumber, liftNumber }) {
  const configs = {
    skiing: {
      label: runNumber ? `On Run ${runNumber}` : 'Skiing',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10',
      borderColor: 'border-blue-500/30',
      pulse: true,
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 21L19 3" />
          <path d="M3 7l4 2" />
          <path d="M17 15l4 2" />
        </svg>
      ),
    },
    traversing: {
      label: 'Traversing',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10',
      borderColor: 'border-blue-500/30',
      pulse: true,
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14" />
          <path d="M12 5l7 7-7 7" />
        </svg>
      ),
    },
    lift: {
      label: liftNumber ? `On Lift ${liftNumber}` : 'On Lift',
      color: 'text-green-400',
      bgColor: 'bg-green-500/10',
      borderColor: 'border-green-500/30',
      pulse: false,
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 20V4" />
          <path d="M20 20V4" />
          <path d="M4 8h16" />
          <circle cx="8" cy="14" r="2" />
          <circle cx="16" cy="14" r="2" />
        </svg>
      ),
    },
    stopped: {
      label: 'Stopped',
      color: 'text-zinc-400',
      bgColor: 'bg-zinc-500/10',
      borderColor: 'border-zinc-500/30',
      pulse: false,
      icon: (
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <rect x="9" y="9" width="6" height="6" rx="1" />
        </svg>
      ),
    },
  };

  const config = configs[type] || configs.stopped;

  return (
    <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border ${config.bgColor} ${config.borderColor}`}>
      {config.pulse && (
        <span className="relative flex h-2.5 w-2.5">
          <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${type === 'skiing' || type === 'traversing' ? 'bg-blue-400' : 'bg-green-400'}`}></span>
          <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${type === 'skiing' || type === 'traversing' ? 'bg-blue-400' : 'bg-green-400'}`}></span>
        </span>
      )}
      <span className={config.color}>{config.icon}</span>
      <span className={`${config.color} font-semibold text-sm`}>{config.label}</span>
    </div>
  );
}
